import React, { Component } from 'react';
import Alert from 'react-bootstrap/Alert';
import Link from 'react-router-dom/Link';
import Button from 'react-bootstrap/Button';

import SearchSoftwarePage from './SearchSoftwarePage.js';

class HomePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: this.props.isAuthenticated,
    };
  }

  componentDidMount() {}

  render() {
    if (this.props.noRender) return null;
    return this.props.isAuthenticated ? (
      <div className="container">
        <h3> Find what you want </h3>
        <p> Search by what you want the product to do or its name. We'll automatically get all the relevant indie results. </p>
        <br />
        <SearchSoftwarePage loggedIn={true}/>
      </div>
    ) : (
      <div className="container">
        <Alert variant="warning">
          <Alert.Heading>Hey, you're not logged in!</Alert.Heading>
          <p>
            Don't know what Softie Pals is all about? The following links will
            clear it all up:
            <br />
            <ul>
              <li>
                <Link to="/about">Connecting users and developers</Link>
              </li>
              <li>
                <Link to="/users">For users</Link>
              </li>
              <li>
                <Link to="/developers">For developers</Link>
              </li>
            </ul>
            Just login or quickly create your account to become a member of the
            indie-user community and start interacting!
          </p>
          <hr />
          <p className="mb-0">
            <Link to="/login">
              <Button>Login now</Button>
            </Link>
          </p>
        </Alert>
        <SearchSoftwarePage loggedIn={false}/>
      </div>
    );
  }
}

export default HomePage;
